import { theme } from '@factorialco/deprecated-design-system'
import { ThemeAPI } from '@ingestro/importer-react'

const spinnerIcon = {
  '& > *': { display: 'none' },
  width: '48px',
  height: '48px',
  border: '4px solid #e5e7eb',
  borderTopColor: '#f43f5e',
  borderRadius: '50%',
  animation: 'spin 0.8s linear infinite',
  '@keyframes spin': {
    to: { transform: 'rotate(360deg)' },
  },
}

export const reviewEntries: ThemeAPI['reviewEntries'] = {
  duplicateButton: {
    display: 'none !important',
  },
  table: {
    td: {
      error: {
        backgroundColor: theme.colors.criticalBackgroundSubtle,
      },
      warning: {
        backgroundColor: theme.colors.warningBackgroundSubtle,
      },
      info: {
        backgroundColor: theme.colors.infoBackgroundSubtle,
      },
    },
  },
  submitModal: {
    icon: {
      display: 'none',
    },
    root: {
      '& span.w-1\\/2': {
        width: 'auto',
        marginRight: theme.dimensions.s8,
      },
    },
  },
  submitLoading: {
    icon: spinnerIcon,
  },
}
